 import React, { useContext, useEffect } from 'react'
 import { store } from '../../stores/admin_templates'
import { Table } from 'reactstrap'
import TemplateRow from './TemplateRow'
import Pusher from 'pusher-js'

 export default function List() {
   const {
     templates,
     pusherAppKey,
     pusherChannel,
     pusherCluster,
     actions,
     dispatch,
   } = useContext(store)

   if (pusherAppKey && pusherChannel) {
     useEffect(() => {
       const socket = new Pusher(pusherAppKey, {
         cluster: pusherCluster,
       })
       socket.subscribe(pusherChannel).bind(`automatedPreview`, (data) => dispatch({
         type: actions.REPLACE_TEMPLATE,
         payload: data.data,
       }))
     }, [])
   }

   return (
     <div className="table-responsive card rounded-1 p-0 m-0 mb-4">
       <Table className="border rounded-1 overflow-hidden m-0">
         <tbody>
           {templates.map(template => <TemplateRow key={template.id} template={template} />)}
         </tbody>
       </Table>
     </div>
   )
 }
